//
//component
import { Button, Col, Flex, Row } from "antd";
//redux
//selector
import { draftDialogSelectedRange } from "store/bailiff/task/dialog/draft_dialog.selector";
//actions
//utils
//hook
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
//str
import sound from "data/sound.json";
import { setDraftDialogSelectedRange } from "store/bailiff/task/dialog/draft_dialog.action";
import {
  BsFastForward,
  BsRewind,
  BsSkipEnd,
  BsSkipStart,
} from "react-icons/bs";
import { useRef } from "react";

const QuickSoundTool = (props) => {
  // -------------------------- VAR -----------------------------
  const { form } = props;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const selectedRange = useSelector(draftDialogSelectedRange);
  const conRef = useRef(null);
  // -------------------------- FUNCTION ------------------------
  const handleClick = (label) => {
    const text = form?.getFieldValue("segment");
    const start = selectedRange.start;
    const end = selectedRange.end;
    const segment = text.slice(0, start) + "(" + label + ")" + text.slice(end);
    form?.setFieldsValue({
      segment: segment,
    });
    dispatch(setDraftDialogSelectedRange({ start: 0, end: 0 }));
  };

  const handleScrollRight = () => {
    const con = conRef.current;
    if (!con) return;
    conRef.current.scrollLeft += 100;
  };

  const handleScrollLeft = () => {
    const con = conRef.current;
    if (!con) return;
    conRef.current.scrollLeft -= 100;
  };

  const handleScrollEndLeft = () => {
    const con = conRef.current;
    if (!con) return;
    conRef.current.scrollLeft = 0;
  };

  const handleScrollEndRight = () => {
    const con = conRef.current;
    if (!con) return;
    conRef.current.scrollLeft = conRef.current.scrollWidth;
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Row
      gutter={4}
      className="mb-5"
      justify={"center"}
      align={"center"}
      wrap={false}
    >
      <Col>
        <Button
          icon={
            <span className="anticon">
              <BsSkipStart />
            </span>
          }
          onClick={handleScrollEndLeft}
          type="text"
          shape="round"
        />
      </Col>
      <Col>
        <Button
          icon={
            <span className="anticon">
              <BsRewind />
            </span>
          }
          onClick={handleScrollLeft}
          type="text"
          shape="round"
        />
      </Col>
      <Col
        className="mx-2 snap-x overflow-hidden scroll-smooth"
        span={"auto"}
        ref={conRef}
      >
        <Flex gap={4}>
          {sound?.map((item, index) => {
            return (
              <Button
                key={index}
                className="w-fit snap-start rounded-3xl border-gray-300 shadow-sm"
                onClick={() => handleClick(item.label)}
              >
                {item.label}
              </Button>
            );
          })}
        </Flex>
      </Col>
      <Col>
        <Button
          icon={
            <span className="anticon">
              <BsFastForward />
            </span>
          }
          onClick={handleScrollRight}
          type="text"
          shape="round"
        />
      </Col>
      <Col>
        <Button
          icon={
            <span className="anticon">
              <BsSkipEnd />
            </span>
          }
          onClick={handleScrollEndRight}
          type="text"
          shape="round"
        />
      </Col>
    </Row>
  );
};
export default QuickSoundTool;
